module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "card": "",
      "light": "",
      "dense": "",
      "flat": ""
    }
  }, [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode === 'page'),
      expression: "mode === 'page'"
    }],
    attrs: {
      "icon": "",
      "light": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.title) + "\n      ")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-scroll', {
    attrs: {
      "md": "",
      "flat": "",
      "offset": _vm.calcOffset(52)
    }
  }, [_c('v-stepper', {
    attrs: {
      "vertical": ""
    },
    model: {
      value: (_vm.currentStep),
      callback: function($$v) {
        _vm.currentStep = $$v
      },
      expression: "currentStep"
    }
  }, [_vm._l((_vm.steps), function(step) {
    return [_c('v-stepper-step', {
      attrs: {
        "complete": _vm.complete(step),
        "step": step.number,
        "editable": ""
      }
    }, [_vm._v("\n            " + _vm._s(step.title) + "\n            "), (step.subTitle) ? _c('small', [_vm._v(_vm._s(typeof step.subTitle === "function" ? step.subTitle(step) : ''))]) : _vm._e()]), _vm._v(" "), _c('v-stepper-content', {
      attrs: {
        "step": step.number
      }
    }, [_c('v-card', {
      attrs: {
        "flat": ""
      }
    }, [_c('v-card-text', [_c(step.class || 'v-step-generator', _vm._b({
      tag: "component",
      model: {
        value: (step.model),
        callback: function($$v) {
          _vm.$set(step, "model", $$v)
        },
        expression: "step.model"
      }
    }, 'component', step.props, false))], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
      attrs: {
        "color": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.next(step)
        }
      }
    }, [_vm._v("Дальше")]), _vm._v(" "), _c('v-btn', {
      attrs: {
        "flat": ""
      },
      on: {
        "click": function($event) {
          return _vm.back(step)
        }
      }
    }, [_vm._v(_vm._s(step.number > 1 ? 'Назад' : 'Отмена'))])], 1)], 1)], 1)]
  })], 2)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.print('docx')
      }
    }
  }, [_vm._v("Составить")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b646a05","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/assist/AssistClaim.vue
// module id = 1158
// module chunks = 1